import {
  type CreatedEntityDestination,
  CreatedEntityFileSaveError,
  saveFilesForOptionalCreatedEntity,
} from '@/utils/createWithFiles';

export const saveDataImportFilesAndValidate = async ({
  createdEntity,
  saveFiles,
  validate,
}: {
  createdEntity?: CreatedEntityDestination;
  saveFiles: () => Promise<void>;
  validate: () => Promise<unknown>;
}): Promise<void> => {
  // Validation reads the attached CSV, so it cannot start until file
  // persistence has completed successfully.
  await saveFilesForOptionalCreatedEntity({ createdEntity, saveFiles });
  try {
    await validate();
  } catch (cause) {
    if (!createdEntity) {
      throw cause;
    }
    throw new CreatedEntityFileSaveError({
      ...createdEntity,
      cause,
      failureStage: 'validation',
    });
  }
};
